import moment from 'moment';
import {
  BUSINESS,
  CUSTOM,
  FREE,
  PRO,
} from '../../assets/constants/PaddleStrings';
import {
  formatDate,
  notification,
  TokenExpiredNotification,
  USER,
} from '../../assets/constants/strings';
import {
  changePassword,
  confirmEmail,
  createBookmark,
  createComment,
  deleteBookmark,
  deleteBookmarks,
  forgotPassword,
  getUserBookmarks,
  logInFromToken,
  register,
  resendConfirmEmail,
  resetPassword,
  revokeToken,
  tryLogin,
  updateUser,
  inviteUser,
  getUserByClientId,
  deleteUser,
  updateClientRole,
  reinviteUser,
  sendEnquiry,
  getUserClient,
  updateClientSubscription,
  getUserPlans,
} from '../../services/axios';
import {
  GetPaddleDiscountById,
  GetPaddleUSer,
  GetPaddleUSerAddress,
  GetPaddleUSerSubscription,
  GetPaddleUserTransactions,
} from '../Paddle/paddleActions';
import {
  SET_USER_LOADING,
  LOG_IN,
  FORGOT_PASS,
  RESET_PASS,
  REGISTER,
  CONFIRM_EMAIL,
  RESEND_EMAIL,
  CREATE_BOOKMARK,
  GET_BOOKMARKS,
  SET_BOOKMARK_LOADING,
  DELETE_BOOKMARK,
  DELETE_BOOKMARKS,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  CLEAR_SUBSCRIPTION_ERROR,
  UPDATE_PASS,
  CLEAR_UPDATE_PASS,
  LOG_OUT,
  CREATE_COMMENT,
  INVITE_USER,
  INVITE_USER_ERROR,
  GET_USERS_BY_CLIENT_ID,
  DELETE_USER_CLIENT,
  SET_USER_CLIENT_ERROR,
  UPDATE_CLIENT_ROLE,
  REINVITE_USER_ERROR,
  REINVITE_USER,
  SEND_ENQUIRY,
  SUBSCRIPTION_UPDATE,
  CREATE_CLIENT_SUBSCRIPTION,
} from './userTypes';

export const setLoading = () => ({
  type: SET_USER_LOADING,
});

export const setBookmarkLoading = () => ({
  type: SET_BOOKMARK_LOADING,
});

export const logOut = () => {
  return async (dispatch, getState) => {
    // dispatch(setLoading());

    // call an endpoint
    const res = await revokeToken();

    if (res.succeeded) {
      notification('success', 'Log out Successful!');

      localStorage.setItem('loggedIn', 'false');

      dispatch({
        type: LOG_OUT,
      });
    } else {
      notification('info', 'Could not log out.');
    }
  };
};

export const logIn = (userName, password) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      let user = null;
      if (userName === null && password === null) user = await logInFromToken();
      else user = await tryLogin(userName, password);
      // client ID = 0, normal user
      // client ID != 0 && role basic, corporate
      // cliebt ID != 0 && role admin, corporate management
      // client ID = 0 && role super admin, 1WordFlow

      // if (user.email === 'superadmin@1wordflow.info') {
      //   localStorage.setItem('loggedIn', 'true');
      //   dispatch({
      //     type: LOG_IN,
      //     payload: {
      //       userID: user.id,
      //       firstName: user.firstName,
      //       lastName: user.lastName,
      //       displayName: `${user.firstName} ${user.lastName}`,
      //       email: user.email,
      //       organisation: user.organisation,
      //       phoneNumber: user.phoneNumber,
      //       isVerified: true,
      //       isActive: true,
      //       spKey: user.spKey,
      //       token: user.jwToken,
      //       userRole: user.roles ? user.roles : 'Super Admin',
      //       isSuperAdmin: true,
      //     },
      //   });
      // }
      // console.log({ user });
      if (user && !user.reason) {
        let userPlan = null;
        let isActive = false;
        let isCorporate = user.accountType === 'corporate' ? true : false;
        let isAdmin = false;
        // let isBasic = false;
        let accountStatus = '';
        let customerPaddleId = '';
        let customerPaddleSubsId = '';
        let userAddress = '';
        let paddleUserSubs = {};
        let restrictions = {};
        let userUsage = {};
        let remainingPageViews = 0;
        let remainingShares = 0;
        let remainingQueries = 0;
        let remainingSummaries = 0;

        if (user.planId === 0 || user.planId === null) {
          remainingPageViews = 100;
          remainingShares = 10;
          remainingQueries = 10;
          remainingSummaries = 10;

          userUsage = {
            [USER.USAGE.PAGEVIEWS]: 0,
            [USER.USAGE.SHARES]: 0,
            [USER.USAGE.QUERIES]: 0,
            [USER.USAGE.SUMMARIES]: 0,
          };
        } else {
          remainingPageViews = user.remainingPageViews;
          remainingShares = user.remainingShares;
          remainingQueries = user.remainingQueries;
          remainingSummaries = user.remainingSummaries;
        }

        //   pageViewUsed: 240,
        //   shareUsed: 20,
        //   queryUsed: 22,
        //   summaryUsed: 24,
        // };

        const userPlans = await getUserPlans(user.jwToken);
        // console.log('userPlans', userPlans);
        let userClient = {};
        userClient = await getUserClient(user.jwToken, user.clientId);
        // console.log('userClient', userClient);

        // const userUsage1 = await getUserUsage(user.jwToken, user.id);
        // console.log('userUsage1', userUsage1);

        const paddleUser = await GetPaddleUSer(user.email);

        let isFree = userClient.paddlePlanType === 'FREE';
        // isActive = userClient.paddlePlanType === 'FREE';

        isActive = user.planId === 0 || user.planId === null ? false : true;

        if (paddleUser && !isFree) {
          customerPaddleId = paddleUser.id;
          // console.log(paddleUser);

          const address = await GetPaddleUSerAddress(paddleUser.id);
          if (address) userAddress = address;
          // console.log('userAddress', userAddress);

          const subs = await GetPaddleUSerSubscription(paddleUser.id);
          // console.log('subs', subs);
          if (subs) {
            // console.log(subs);
            paddleUserSubs = subs;
            isActive = paddleUserSubs.status === 'active';
            accountStatus = paddleUserSubs.status;
            customerPaddleSubsId = paddleUserSubs.id;
          }

          if (
            customerPaddleSubsId !== null ||
            (customerPaddleSubsId !== null && isCorporate && isAdmin)
          ) {
            // console.log({ paddleUserSubs });
            if (
              paddleUserSubs &&
              Object.keys(paddleUserSubs).length !== 0 &&
              paddleUserSubs !== null
            ) {
              const subscriptionName = paddleUserSubs.items[0].price.name;

              restrictions = {
                [USER.USAGE.PAGEVIEWS]:
                  subscriptionName === PRO.name
                    ? PRO.pagesView
                    : subscriptionName === BUSINESS.name
                    ? BUSINESS.pagesView
                    : CUSTOM.pagesView,
                [USER.USAGE.SHARES]:
                  subscriptionName === PRO.name
                    ? PRO.pagesShared
                    : subscriptionName === BUSINESS.name
                    ? BUSINESS.pagesShared
                    : CUSTOM.pagesShared,
                [USER.USAGE.QUERIES]:
                  subscriptionName === PRO.name
                    ? user.remainingAdditionalQueries
                      ? user.remainingAdditionalQueries + PRO.queries
                      : PRO.queries
                    : subscriptionName === BUSINESS.name
                    ? user.remainingAdditionalQueries
                      ? user.remainingAdditionalQueries + BUSINESS.queries
                      : BUSINESS.queries
                    : subscriptionName === CUSTOM.name
                    ? user.remainingAdditionalQueries
                      ? user.remainingAdditionalQueries + CUSTOM.queries
                      : CUSTOM.queries
                    : 0,
                [USER.USAGE.SUMMARIES]:
                  subscriptionName === PRO.name
                    ? PRO.summary
                    : subscriptionName === BUSINESS.name
                    ? BUSINESS.summary
                    : CUSTOM.summary,
              };

              const pageViewsNumber =
                subscriptionName === PRO.name
                  ? PRO.pagesView - user.remainingPageViews
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.pagesView - user.remainingPageViews
                  : CUSTOM.pagesView - user.remainingPageViews;

              const sharesNumber =
                subscriptionName === PRO.name
                  ? PRO.pagesShared - user.remainingShares
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.pagesShared - user.remainingShares
                  : CUSTOM.pagesShared - user.remainingShares;

              const queriesNumber =
                subscriptionName === PRO.name
                  ? PRO.queries - user.remainingQueries
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.queries - user.remainingQueries
                  : CUSTOM.queries - user.remainingQueries;

              const summariesNumber =
                subscriptionName === PRO.name
                  ? PRO.summary - user.remainingSummaries
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.summary - user.remainingSummaries
                  : CUSTOM.summary - user.remainingSummaries;

              userUsage = {
                [USER.USAGE.PAGEVIEWS]: pageViewsNumber,
                [USER.USAGE.SHARES]: sharesNumber,
                [USER.USAGE.QUERIES]: queriesNumber,
                [USER.USAGE.SUMMARIES]: summariesNumber,
                [USER.USAGE.ADDITIONALQUERIES]: user.remainingAdditionalQueries,
              };

              let userDiscount = {};
              if (paddleUserSubs.discount && paddleUserSubs.discount.id) {
                const discountRes = await GetPaddleDiscountById(
                  paddleUserSubs.discount.id
                );

                userDiscount = {
                  amount: discountRes.amount ? discountRes.amount : '',
                  createdAt: discountRes.created_at
                    ? formatDate(discountRes.created_at)
                    : '',
                  type: discountRes.type ? discountRes.type : '',
                  description: discountRes.description
                    ? discountRes.description
                    : '',
                };
              }

              userPlan = {
                subscriptionID: paddleUserSubs.id,
                subscriptionName: subscriptionName,
                billingPeriod:
                  paddleUserSubs.billing_cycle.interval === 'month'
                    ? 'Monthly'
                    : '',
                price: paddleUserSubs.items[0].price.unit_price.amount / 100,
                currency: paddleUserSubs.currency_code,
                status: paddleUserSubs.status,
                startedAt:
                  paddleUserSubs.current_billing_period &&
                  paddleUserSubs.current_billing_period.starts_at
                    ? formatDate(
                        paddleUserSubs.current_billing_period.starts_at
                      )
                    : '',
                nextBilling:
                  paddleUserSubs.current_billing_period &&
                  paddleUserSubs.current_billing_period.ends_at
                    ? formatDate(paddleUserSubs.current_billing_period.ends_at)
                    : '',
                restrictions: restrictions,
                accountStatus: accountStatus,
                planId: user.planId,
                userDiscount: userDiscount,
              };
            }
          }

          localStorage.setItem('loggedIn', 'true');

          dispatch({
            type: LOG_IN,
            payload: {
              userID: user.id,
              firstName: user.firstName,
              lastName: user.lastName,
              displayName: `${user.firstName} ${user.lastName}`,
              email: user.email,
              // organisation: user.organisation,
              phoneNumber: user.phoneNumber,
              isVerified: true,
              firstTimeLogin: user.firstTimeLogin,
              isActive: isActive,
              spKey: user.spKey,
              token: user.jwToken,
              // clientId: user.clientId,
              isCorporate: isCorporate,
              isAdmin: true,
              jobTitle: user.jobTitle,
              // accountType: user.accountType,
              // accountStatus: accountStatus,
              customerPaddleId: customerPaddleId,
              customerPaddleSubsId: customerPaddleSubsId,
              userAddress: userAddress,
              userPlan: userPlan,
              userUsage: userUsage,
              userClient: userClient,
              userPlans: userPlans,
              remainingPageViews: remainingPageViews,
              remainingQueries: remainingQueries,
              remainingSummaries: remainingSummaries,
              remainingShares: remainingShares,
              remainingAdditionalQueries: user.remainingAdditionalQueries,
              // isBasic: isBasic,
              // userRole: user.roles,
              // selectedUserTier: user.selectedUserTier,
              // activeUserTier: user.activeUserTier,
              // subscriptionId: user.subscriptionId,
            },
          });
        } else {
          localStorage.setItem('loggedIn', 'true');

          if (user.planId === 0 || user.planId === null) {
            remainingPageViews = 100;
            remainingShares = 10;
            remainingQueries = 10;
            remainingSummaries = 10;

            userUsage = {
              [USER.USAGE.PAGEVIEWS]: 0,
              [USER.USAGE.SHARES]: 0,
              [USER.USAGE.QUERIES]: 0,
              [USER.USAGE.SUMMARIES]: 0,
            };
          } else {
            remainingPageViews = user.remainingPageViews;
            remainingShares = user.remainingShares;
            remainingQueries = user.remainingQueries;
            remainingSummaries = user.remainingSummaries;

            userUsage = {
              [USER.USAGE.PAGEVIEWS]: FREE.pagesView - user.remainingPageViews,
              [USER.USAGE.SHARES]: FREE.pagesShared - user.remainingShares,
              [USER.USAGE.QUERIES]: FREE.queries - user.remainingQueries,
              [USER.USAGE.SUMMARIES]: FREE.summary - user.remainingSummaries,
            };
          }

          userPlan = {
            subscriptionName: 'Free',
            startedAt: user.startDate ? formatDate(user.startDate) : '',
            endDate: user.endDate ? formatDate(user.endDate) : '',
            restrictions: {
              [USER.USAGE.PAGEVIEWS]: FREE.pagesView,
              [USER.USAGE.SHARES]: FREE.pagesShared,
              [USER.USAGE.QUERIES]: user.remainingAdditionalQueries
                ? FREE.queries + user.remainingAdditionalQueries
                : FREE.queries,
              [USER.USAGE.SUMMARIES]: FREE.summary,
            },
            planId: user.planId,
          };

          const startDate = new Date(user.startDate);
          const finishDate = new Date(user.endDate);
          const today = new Date();

          // console.log('startDate', startDate);
          // console.log('finishDate', finishDate);
          // console.log('today', today);

          let dateResult = today >= startDate && today <= finishDate;

          // console.log('dateResult', dateResult);

          if (!dateResult && isActive) {
            const start = new Date(finishDate).toISOString();
            const finish = moment(start).add(1, 'month');
            const renewOn = new Date(finish).toISOString();

            // console.log('start', start);
            // console.log('renewOn', renewOn);

            const data = {
              clientId: userClient.id,
              startDate: new Date().toISOString(),
              endDate: new Date(renewOn).toISOString(),
              // paddlePlanType: 'FREE',
              paddleCustomerId: '',
              paddleSubscriptionId: '',
              paddlePriceId: '',
              // planId: '',
            };

            const res = await updateClientSubscription(data, user.jwToken);

            if (res && res.success) {
              userPlan = {
                subscriptionName: 'Free',
                startedAt: start ? formatDate(start) : '',
                endDate: renewOn ? formatDate(renewOn) : '',
                restrictions: {
                  pagesView: FREE.pagesView,
                  pagesShared: FREE.pagesShared,
                  queries: FREE.queries,
                  summary: FREE.summary,
                },
              };
              // isActive = true;
            }
          }

          dispatch({
            type: LOG_IN,
            payload: {
              userID: user.id,
              firstName: user.firstName,
              lastName: user.lastName,
              displayName: `${user.firstName} ${user.lastName}`,
              email: user.email,
              organisation: user.organisation,
              phoneNumber: user.phoneNumber,
              isVerified: true,
              firstTimeLogin: user.firstTimeLogin,
              isActive: isActive,
              spKey: user.spKey,
              token: user.jwToken,
              // clientId: user.clientId,
              isAdmin: true,
              jobTitle: user.jobTitle,
              accountType: 'individual',
              accountStatus: 'active',
              userPlan: userPlan,
              userUsage: userUsage,
              userClient: userClient,
              userPlans: userPlans,
              remainingPageViews: remainingPageViews,
              remainingQueries: remainingQueries,
              remainingSummaries: remainingSummaries,
              remainingShares: remainingShares,
              remainingAdditionalQueries: user.remainingAdditionalQueries,
              // customerPaddleId: customerPaddleId,
              // customerPaddleSubsId: customerPaddleSubsId,
              // userAddress: userAddress,
              // isCorporate: false,
              // isBasic: false,
              // userRole: ['Admin'],
              // selectedUserTier: user.selectedUserTier,
              // activeUserTier: user.activeUserTier,
              // subscriptionId: user.subscriptionId,
            },
          });
        }
      } else {
        dispatch({
          type: LOG_IN,
          payload: user,
        });
      }
    } catch (e) {
      console.log('ERROR logging in', e);
      dispatch({
        type: LOG_IN,
        payload: {
          success: false,
          reason: e.message,
          request: LOG_IN,
        },
      });
    }
  };
};

export const clearSubscriptionError = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SUBSCRIPTION_ERROR,
  });
};

export const updatePassword = (passObj) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const token = getState().user.user.token;
    const userID = getState().user.user.userID;

    passObj = {
      id: userID,
      ...passObj,
    };

    const res = await changePassword(passObj, token);

    if (
      res.success === false &&
      res.reason &&
      res.reason.match('The token is expired')
    ) {
      res.reason = 'Session Expired.';
      TokenExpiredNotification();
    }

    dispatch({
      type: UPDATE_PASS,
      payload: res,
    });
  };
};

export const clearUpdatePass = () => async (dispatch) => {
  dispatch({
    type: CLEAR_UPDATE_PASS,
  });
};

export const updateUserInfo = (userObj, isFirstTimeLogin = false) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const token = getState().user.user.token;
    let user = getState().user.user;

    const res = await updateUser(userObj, token);

    if (res.success) {
      if (!isFirstTimeLogin) {
        notification('success', 'Your details were updated!');

        user = {
          ...user,
          firstName: userObj.firstName,
          lastName: userObj.lastName,
          displayName: userObj.firstName + ' ' + userObj.lastName,
          phoneNumber: userObj.phoneNumber,
          organisation: userObj.organisation,
          userClient: {
            ...user.userClient,
            name: userObj.organisation,
          },
        };
      } else {
        user = {
          ...user,
          firstTimeLogin: userObj.firstTimeLogin,
        };
      }

      dispatch({
        type: UPDATE_USER,
        payload: user,
      });
    } else {
      if (res.reason && res.reason.match('The token is expired')) {
        res.reason = 'Session Expired.';
        TokenExpiredNotification();
      } else {
        notification(
          'info',
          'Error',
          `Could update your details. ${
            res.reason
              ? res.reason
              : 'Please try again. If the issue persists, restart the app.'
          }`
        );
      }

      dispatch({
        type: UPDATE_USER_ERROR,
        payload: res,
      });
    }
    return res;
  };
};

export const forgotPass = (email) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await forgotPassword(email);

    dispatch({
      type: FORGOT_PASS,
      payload: res,
    });
  };
};

export const resetPass = (email, token, password, confirmPassword) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await resetPassword(email, token, password, confirmPassword);

    // console.log(res);

    dispatch({
      type: RESET_PASS,
      payload: res,
    });
  };
};

export const registerUser = (user) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await register(user);

    // console.log(res);

    dispatch({
      type: REGISTER,
      payload: res,
    });
  };
};

export const resendEmail = (userId, email) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await resendConfirmEmail(userId, email);

    if (res.success === true) {
      notification('success', 'Email resent! Please check your spam folder.');
    } else {
      notification(
        'info',
        'Error',
        `Could not send email. ${
          res.reason
            ? res.reason
            : 'Please try again. If the issue persists, restart the app.'
        }`
      );
    }

    // setTimeout(() => {
    dispatch({
      type: RESEND_EMAIL,
      payload: res,
    });
    // }, 2500);
  };
};

export const confirmUser = (userId, code) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await confirmEmail(userId, code);

    // console.log(res);

    dispatch({
      type: CONFIRM_EMAIL,
      payload: res,
    });
  };
};

export const getBookmarks = () => {
  return async (dispatch, getState) => {
    if (getState().user.bookmarkLoading === 0) {
      dispatch(setBookmarkLoading());

      const token = getState().user.user.token;
      const userId = getState().user.user.userID;

      // call an endpoint
      const res = await getUserBookmarks(userId, token);

      dispatch({
        type: GET_BOOKMARKS,
        payload: res,
      });
    }
  };
};

export const CreateBookmark = (bookmarkObj) => {
  return async (dispatch, getState) => {
    dispatch(setBookmarkLoading());

    const token = getState().user.user.token;
    const userID = getState().user.user.userID;

    bookmarkObj = {
      ...bookmarkObj,
      userId: userID,
    };

    // call an endpoint
    const res = await createBookmark(bookmarkObj, token);

    let bookmarks = getState().user.bookmarks
      ? [...getState().user.bookmarks]
      : [];

    if (res.success === true) {
      notification('success', 'Bookmark added!', undefined, undefined, 3.5);
      bookmarks.push(res.newBookmark);
    } else {
      if (res.reason && res.reason.match('The token is expired')) {
        res.reason = 'Session Expired.';
        TokenExpiredNotification();
      } else
        notification(
          'info',
          'Error',
          `Could not save bookmark. ${
            res.reason
              ? res.reason
              : 'Please try again. If the issue persists, restart the app.'
          }`
        );
    }

    dispatch({
      type: CREATE_BOOKMARK,
      payload: bookmarks,
    });
  };
};

export const CreateComment = (text) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const userID = getState().user.user.userID;
    const name = getState().user.user ? getState().user.user.firstName : null;

    const commentObj = {
      text: text,
      userId: userID,
    };

    // call an endpoint
    const res = await createComment(commentObj);

    if (res.success === true) {
      notification(
        'success',
        `Thank you for your feedback${name !== null ? ', ' + name : ''}!`,
        'Our team will review your comment and get in touch with you shortly.'
      );
    } else {
      notification(
        'info',
        `Sorry${
          name !== null ? ' ' + name : ''
        }, we could not save comment. Please try again. If the issue persists, restart the app.`
      );
    }

    dispatch({
      type: CREATE_COMMENT,
    });
  };
};

export const DeleteBookmark = (pageId) => {
  return async (dispatch, getState) => {
    dispatch(setBookmarkLoading());

    const token = getState().user.user.token;

    // console.log('Delete', pageId);

    // call an endpoint
    const res = await deleteBookmark(pageId, token);

    let bookmarks = getState().user.bookmarks
      ? [...getState().user.bookmarks]
      : [];

    if (res.success === true) {
      notification('success', 'Bookmark removed!', undefined, undefined, 3.5);
      bookmarks = bookmarks.filter((bookmark) => bookmark.id !== pageId);
    } else {
      if (res.reason && res.reason.match('The token is expired')) {
        res.reason = 'Session Expired.';
        TokenExpiredNotification();
      } else
        notification(
          'info',
          'Error',
          `Could not remove bookmark. ${
            res.reason
              ? res.reason
              : 'Please try again. If the issue persists, restart the app.'
          }`
        );
    }

    dispatch({
      type: DELETE_BOOKMARK,
      payload: bookmarks,
    });
  };
};

export const DeleteBookmarks = (bookmarksList) => {
  return async (dispatch, getState) => {
    dispatch(setBookmarkLoading());

    const token = getState().user.user.token;

    // call an endpoint
    const res = await deleteBookmarks(bookmarksList, token);

    let bookmarks = getState().user.bookmarks
      ? [...getState().user.bookmarks]
      : [];

    if (res.success === true) {
      notification('success', 'Bookmark(s) removed!');

      bookmarksList.forEach((deletedBookmark) => {
        bookmarks = bookmarks.filter(
          (bookmark) => bookmark.id !== deletedBookmark.id
        );
      });
    } else {
      if (res.reason && res.reason.match('The token is expired')) {
        res.reason = 'Session Expired.';
        TokenExpiredNotification();
      } else
        notification(
          'info',
          'Error',
          `Could not remove bookmark(s). ${
            res.reason
              ? res.reason
              : 'Please try again. If the issue persists, restart the app.'
          }`
        );
    }

    dispatch({
      type: DELETE_BOOKMARKS,
      payload: bookmarks,
    });
  };
};

// invite user to corporate account
export const InviteUser = (newUser) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const isAdmin = getState().user.user.isAdmin;
    const token = getState().user.user.token;
    const usersByClient = getState().user.usersByClient
      ? [...getState().user.usersByClient]
      : [];

    getState().user.newUser = newUser;

    // call an endpoint
    const res = await inviteUser(newUser, token);

    if (isAdmin) {
      if (res.success === true) {
        usersByClient.push(res.newUser);

        notification('success', 'User Added');

        dispatch({
          type: INVITE_USER,
          payload: usersByClient,
        });
      } else {
        if (res.reason && res.reason.match('The token is expired')) {
          res.reason = 'Session Expired.';
          TokenExpiredNotification();
        } else if (
          res.reason &&
          !res.reason.includes(
            'Account with this email is already added to your organisation'
          )
        )
          notification(
            'info',
            'Error',
            `Could not add user. ${
              res.reason
                ? res.reason
                : 'Please try again. If the issue persists, restart the app.'
            }`
          );

        dispatch({
          type: INVITE_USER_ERROR,
          payload: res,
        });
      }
    } else {
      notification(
        'info',
        'Error',
        `Could not invite user. ${
          res.reason
            ? res.reason
            : 'Please try again. If the issue persists, restart the app.'
        }`
      );

      dispatch({
        type: INVITE_USER_ERROR,
        payload: res,
      });
    }
  };
};

export const getUsersByClientId = () => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const clientId = getState().user.user.clientId;
    const token = getState().user.user.token;
    const isAdmin = getState().user.user.isAdmin;

    // call an endpoint
    const res = await getUserByClientId(clientId, token);

    if (isAdmin && clientId) {
      if (res && res.reason && res.reason.match('The token is expired')) {
        res.reason = 'Session Expired.';
        TokenExpiredNotification();
      }

      // console.log(res, clientId);

      dispatch({
        type: GET_USERS_BY_CLIENT_ID,
        payload: res,
      });
    } else {
      dispatch({
        type: SET_USER_CLIENT_ERROR,
        payload: res,
      });
    }
  };
};

export const DeleteUser = (userId) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const token = getState().user.user.token;
    const clientId = getState().user.user.clientId;
    const isAdmin = getState().user.user.isAdmin;

    // let usersByClient = getState().user.usersByClient ? [...getState().user.usersByClient] : [];

    // console.log('Delete', userId);

    // call an endpoint
    const res = await deleteUser(clientId, userId, token);

    const clientUsers = await getUserByClientId(clientId, token);

    if (isAdmin) {
      if (res.success === true) {
        // usersByClient = usersByClient.filter((user) => user.id !== userId);

        notification('success', 'The user has been removed from your account.');

        dispatch({
          type: DELETE_USER_CLIENT,
          payload: clientUsers,
        });
      } else {
        if (res.reason && res.reason.match('The token is expired')) {
          res.reason = 'Session Expired.';
          TokenExpiredNotification();
        } else
          notification(
            'info',
            'Error',
            `Could not remove user. ${
              res.reason
                ? res.reason
                : 'Please try again. If the issue persists, restart the app.'
            }`
          );

        dispatch({
          type: SET_USER_CLIENT_ERROR,
          payload: res,
        });
      }
    } else {
      notification(
        'info',
        'Error',
        `Could not remove user. ${
          res.reason
            ? res.reason
            : 'Please try again. If the issue persists, restart the app.'
        }`
      );

      dispatch({
        type: SET_USER_CLIENT_ERROR,
        payload: [],
      });
    }
  };
};

export const UpdateClientRole = (data) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const token = getState().user.user.token;
    const isAdmin = getState().user.user.isAdmin;

    // call an endpoint
    const res = await updateClientRole(data, token);

    // console.log('res UPDATE role', res);

    if (isAdmin) {
      if (res.success === true) {
        notification('success', 'User role updated.');

        dispatch({
          type: UPDATE_CLIENT_ROLE,
        });
      } else {
        if (res.reason && res.reason.match('The token is expired')) {
          res.reason = 'Session Expired.';
          TokenExpiredNotification();
        } else
          notification(
            'info',
            'Error',
            `Could not update user role. ${
              res.reason
                ? res.reason
                : 'Please try again. If the issue persists, restart the app.'
            }`
          );

        dispatch({
          type: SET_USER_CLIENT_ERROR,
        });
      }
    } else {
      notification(
        'info',
        'Error',
        `Could not update user role. ${res.reason}. Please try again. If the issue persists, restart the app.`
      );

      dispatch({
        type: SET_USER_CLIENT_ERROR,
      });
    }
  };
};

// reinvite inactive (already exists but user invited account status = inactive) to corporate account
export const ReinviteUser = (email, clientId) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const token = getState().user.user.token;
    const isAdmin = getState().user.user.isAdmin;

    // call an endpoint
    const res = await reinviteUser(email, clientId, token);
    // call an endpoint
    const clientUsers = await getUserByClientId(clientId, token);

    if (isAdmin) {
      if (res.success === true) {
        notification('success', 'Account reactivated.');

        dispatch({
          type: REINVITE_USER,
          payload: clientUsers,
        });
      } else {
        console.log(res);
        notification('info', 'Error', 'Could not reactivate account.');

        dispatch({
          type: REINVITE_USER_ERROR,
          payload: res,
        });
      }
    } else {
      notification('info', 'Error', 'Could not reactivate account.');

      dispatch({
        type: REINVITE_USER_ERROR,
        payload: res,
      });
    }
  };
};

export const sendQuote = (quote) => {
  return async (dispatch) => {
    dispatch(setLoading());

    // call an endpoint
    const res = await sendEnquiry(quote);

    // console.log(res);

    if (res.success === true) {
      dispatch({
        type: SEND_ENQUIRY,
        payload: res,
      });
    } else {
      notification(
        'info',
        'Error',
        'Could not sent enquiry. Please, try again.'
      );
      dispatch({
        type: SEND_ENQUIRY,
        payload: res,
      });
    }
  };
};

export const cleanSubscription = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: SUBSCRIPTION_UPDATE,
      payload: null,
    });
  };
};

export const cleanEnquiry = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: SEND_ENQUIRY,
      payload: null,
    });
  };
};

export const UpdateClientSubscription = (clientObj) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    const currentUser = getState().user.user;

    let userPlan = null;
    let isActive = false;
    let isCorporate = currentUser.accountType === 'corporate' ? true : false;
    let isAdmin = false;
    let accountStatus = '';
    let customerPaddleSubsId = '';
    let userAddress = '';
    let paddleUserSubs = {};
    let restrictions = {};
    let user = {};

    const updateRes = await updateClientSubscription(
      clientObj,
      currentUser.token
    );
    // console.log('updateClientSubscription', res);

    let userClient = await getUserClient(currentUser.token, clientObj.clientId);
    let customerPaddleId = '';

    const userUsage = {
      pageviews: 0,
      shares: 0,
      queries: 0,
      summaries: 0,
    };

    if (updateRes && updateRes.success) {
      if (clientObj.paddlePlanType !== 'FREE') {
        const paddleUser = await GetPaddleUSer(currentUser.email);
        customerPaddleId = paddleUser.id;
        // console.log("paddleUser", paddleUser);
        GetPaddleUserTransactions(paddleUser.customer_id);

        const address = await GetPaddleUSerAddress(paddleUser.id);
        if (address) userAddress = address;
        // console.log('userAddress', userAddress);

        const subs = await GetPaddleUSerSubscription(paddleUser.id);
        if (subs) {
          // console.log(subs);
          paddleUserSubs = subs;
          isActive = paddleUserSubs.status === 'active';
          accountStatus = paddleUserSubs.status;
          customerPaddleSubsId = paddleUserSubs.id;
        }

        if (
          customerPaddleSubsId !== null ||
          (customerPaddleSubsId !== null && isCorporate && isAdmin)
        ) {
          if (paddleUserSubs && paddleUserSubs !== null) {
            const subscriptionName = paddleUserSubs.items[0].price.name;

            restrictions = {
              [USER.USAGE.PAGEVIEWS]:
                subscriptionName === PRO.name
                  ? PRO.pagesView
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.pagesView
                  : CUSTOM.pagesView,
              [USER.USAGE.SHARES]:
                subscriptionName === PRO.name
                  ? PRO.pagesShared
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.pagesShared
                  : CUSTOM.pagesShared,
              [USER.USAGE.QUERIES]:
                subscriptionName === PRO.name
                  ? currentUser.remainingAdditionalQueries
                    ? currentUser.remainingAdditionalQueries + PRO.queries
                    : PRO.queries
                  : subscriptionName === BUSINESS.name
                  ? currentUser.remainingAdditionalQueries
                    ? currentUser.remainingAdditionalQueries + BUSINESS.queries
                    : BUSINESS.queries
                  : subscriptionName === CUSTOM.name
                  ? currentUser.remainingAdditionalQueries
                    ? currentUser.remainingAdditionalQueries + CUSTOM.queries
                    : CUSTOM.queries
                  : 0,
              [USER.USAGE.SUMMARIES]:
                subscriptionName === PRO.name
                  ? PRO.summary
                  : subscriptionName === BUSINESS.name
                  ? BUSINESS.summary
                  : CUSTOM.summary,
            };

            userPlan = {
              subscriptionID: paddleUserSubs.id,
              subscriptionName: subscriptionName,
              billingPeriod:
                paddleUserSubs.billing_cycle.interval === 'month'
                  ? 'Monthly'
                  : '',
              price: paddleUserSubs.items[0].price.unit_price.amount / 100,
              currency: paddleUserSubs.currency_code,
              status: paddleUserSubs.status,
              startedAt:
                paddleUserSubs.current_billing_period &&
                paddleUserSubs.current_billing_period.starts_at
                  ? formatDate(paddleUserSubs.current_billing_period.starts_at)
                  : '',
              nextBilling:
                paddleUserSubs.current_billing_period &&
                paddleUserSubs.current_billing_period.ends_at
                  ? formatDate(paddleUserSubs.current_billing_period.ends_at)
                  : '',
              restrictions: restrictions,
              accountStatus: accountStatus,
            };
          }
        }
      } else {
        isActive = clientObj.paddlePlanType === 'FREE';
        userPlan = {
          subscriptionName: 'Free',
          startedAt: clientObj.startDate ? formatDate(clientObj.startDate) : '',
          endDate: clientObj.endDate ? formatDate(clientObj.endDate) : '',
          restrictions: {
            [USER.USAGE.PAGEVIEWS]: FREE.pagesView,
            [USER.USAGE.SHARES]: FREE.pagesShared,
            [USER.USAGE.QUERIES]: currentUser.remainingAdditionalQueries
              ? FREE.queries + currentUser.remainingAdditionalQueries
              : FREE.queries,
            [USER.USAGE.SUMMARIES]: FREE.summary,
          },
        };
      }

      user = {
        ...currentUser,
        userPlan: userPlan,
        userUsage: userUsage,
        remainingPageViews: updateRes.data.remainingPageViews,
        remainingShares: updateRes.data.remainingShares,
        remainingQueries: updateRes.data.remainingQueries,
        remainingSummaries: updateRes.data.remainingSummaries,
        customerPaddleId:
          clientObj.paddlePlanType === 'FREE' ? '' : customerPaddleId,
        customerPaddleSubsId:
          clientObj.paddlePlanType === 'FREE' ? '' : customerPaddleSubsId,
        isActive: isActive,
        userClient: userClient,
        userAddress: userAddress,
      };
      dispatch({
        type: CREATE_CLIENT_SUBSCRIPTION,
      });
      dispatch({
        type: UPDATE_USER,
        payload: user,
      });
    } else {
      notification(
        'info',
        'Error',
        'Could not update subscription. Please try again. If the issue persists, restart the app.'
      );

      dispatch({
        type: UPDATE_USER_ERROR,
        payload: updateRes,
      });
    }
    return updateRes;
  };
};
